'use strict'

const $ = require('jquery');
const cookie = require('cookies-js');
const DISMISSALS_COOKIE_NAME = 'dismissed_notices';
const COOKIE_ARRAY_DELIMITER = ',';
const activeClassName = 'is-active';
const nextClassName = 'js-next';
const prevClassName = 'js-prev';
const dismissClassName = 'js-dismiss';
const noticeClassName = 'js-notice';
const progressClassName = 'js-progress';

module.exports = function notices({ className }) {
	const container = document.querySelector(`.${className}`);
	const next = container.querySelector(`.${nextClassName}`);
	const prev = container.querySelector(`.${prevClassName}`);
	const dismiss = container.querySelector(`.${dismissClassName}`);
	const progress = container.querySelector(`.${progressClassName}`);
	const applyUpdate = updateUi({ container, prev, next, dismiss, progress });
	const applyShowNext = showNext( applyUpdate);
	const applyShowPrev = showPrev( applyUpdate);
	const applyDismissCurrent = dismissCurrent(container, applyUpdate, applyShowPrev, applyShowNext);

	removeNotices(container)(getStoredDismissals());

	let state = {
		currentIndex: 0,
		notices: container.querySelectorAll(`.${noticeClassName}`),
		theme: null
	};

	applyUpdate(state);

	next.addEventListener('click', () =>
		state = applyShowNext(state) || state);

	prev.addEventListener('click', () =>
		state = applyShowPrev(state) || state);

	dismiss.addEventListener('click', ({ target }) =>
		state = applyDismissCurrent(state) || state);
}

const showNext = applyUpdate => state => {
	if(state.currentIndex === state.notices.length - 1) {
		return false;
	}

	state.currentIndex += 1;
	applyUpdate(state);
	return state;
}

const showPrev = applyUpdate => state => {
	if(state.currentIndex === 0) {
		return false;
	}

	state.currentIndex -= 1;
	applyUpdate(state);
	return state;
}

const dismissCurrent = (container, applyUpdate, applyShowPrev, applyShowNext) => state => {
	const dismissable = canDismissCurrent(state);
	const current = getCurrent(state);
	let nextState = state;

	if(!dismissable) {
		return nextState;
	}

	if(nextState.notices.length === 0) {
		return nextState();
	}

	if(nextState.currentIndex === nextState.notices.length - 1) {
		nextState.currentIndex -= 1;
	}

	removeNode(current);
	nextState.notices = container.querySelectorAll(`.${noticeClassName}`);
	applyUpdate(nextState);
	storeDismissal(elementData(current, 'id'))
	return nextState;
}

const updateUi = ({ container, prev, next, dismiss, progress }) => state => {
	const dismissable = canDismissCurrent(state);
	const current = getCurrent(state);
	const nextTheme = elementData(current, 'theme');

	if(nextTheme !== state.theme) {
		removeClassName(container, themeClassName(state.theme))
		state.theme = nextTheme;
		addClassName(container, themeClassName(state.theme))
	}

	[].forEach.call(state.notices, notice => {
		hide(notice);
	});

	if(state.notices.length === 0) {
		removeClassName(container, activeClassName);
	} else {
		addClassName(container, activeClassName);
	}

	show(current);

	if(state.currentIndex === 0) {
		removeClassName(prev, activeClassName);
	} else {
		addClassName(prev, activeClassName);
	}

	if(state.currentIndex === state.notices.length - 1) {
		removeClassName(next, activeClassName);
	} else {
		addClassName(next, activeClassName);
	}

	if(!dismissable) {
		removeClassName(dismiss, activeClassName);
	} else {
		addClassName(dismiss, activeClassName);
	}

	progress.innerText = `${state.currentIndex + 1} of ${state.notices.length}`;
}

const canDismissCurrent = state => {
	const notice = getCurrent(state);
	return notice && elementData(notice, 'dismissable') && elementData(notice, 'dismissable') === 1;
}

const getCurrent = state =>
	state.notices[state.currentIndex];

const storeDismissal = id => {
	const storedDismissals = getStoredDismissals();

	if(storedDismissals.indexOf(id) > -1) {
		return;
	}

	storedDismissals.push(id);

	cookie.set(
		DISMISSALS_COOKIE_NAME,
		storedDismissals.join(COOKIE_ARRAY_DELIMITER),
		{ expires: Infinity }
	);
};

const getStoredDismissals = () => {
	const string = cookie.get(DISMISSALS_COOKIE_NAME);
	return string
		? string.split(COOKIE_ARRAY_DELIMITER)
		: [];
};

const removeNotices = container => ids => {
	ids.forEach(id => {
		const notice = container
			.querySelector(`[data-id='${id}']`);
		removeNode(notice);
	});
};

const show = element =>
	addClassName(element, activeClassName);

const hide = element =>
	removeClassName(element, activeClassName);

const elementData = (element, key) =>
	$(element).data(key);

const addClassName = (element, className) =>
	$(element).addClass(className);

const removeClassName = (element, className) =>
	$(element).removeClass(className);

const removeNode = element =>
	$(element).remove();

const themeClassName = theme =>
	`t-${theme}`